module.exports = __webpack_public_path__ + "media/images/mypage/icon/blue/ico_angle_right-3cae16ffaf45bb9869f0be19c9018926.svg";